import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import {Card} from "primereact/card";
import { useProject } from "../context/ProjectContextProvider";
import ProjectContextDropdown from '../components/ProjectContextDropdown';
import { useAuth } from '../AuthProvider'

export default function CxChecklistPage() {
    const [allChecklists, setAllChecklists] = useState(null);
    const toast = useRef(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const { project } = useProject();
    const { keycloak } = useAuth()

    const [columns, setColumns] = useState([
        {field: 'name', header: 'Name'},
        {field: 'assignmentReference', header: 'Assignment Reference'},
        {field: 'drawingReference', header: 'Drawing Reference'},
        {field: 'specReference', header: 'Spec Reference'},
        {field: 'active', header: 'Active'}
    ]);

    const fetchChecklists = async () => {
        try {
            await keycloak.updateToken(30);

            const checklistByProject = await fetch(`${endpoints.checklistbyproject}${project.value}`, {
            // const checklistByProject = await fetch(Endpoints["checklistbyproject"] + project.value, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!checklistByProject.ok) {
                throw new Error("Logs: Bad response");
            }

            const checklistsData = await checklistByProject.json();
            setAllChecklists(checklistsData);
        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchChecklists();
    }, []);

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Checklists
            </span>
        </div>
    );

    const handleProjectSelection = async (e) => {
        console.log(e);
        await keycloak.updateToken(30);

        const checklistByProject = await fetch(`${endpoints.checklistbyproject}${e}`, {
        // const checklistByProject = await fetch(Endpoints["checklistbyproject"], {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${keycloak.token}`,
            },
        });

        if (!checklistByProject.ok) {
            throw new Error("Logs: Bad response");
        }

        const checklistsData = await checklistByProject.json();
        setAllChecklists(checklistsData);
    };

    const rowExpansionTemplate = (data) => {
        return (
            <div className="p-3">
                <Card subTitle="Checklist Items">
                <DataTable value={data.checklists}>
                    <Column field="id" header="Id" sortable></Column>
                    <Column field="checklistItem" header="Checklist Item" sortable></Column>
                    <Column field="responsibleRoleName" header="Responsible Role" sortable></Column>
                    <Column field="acceptanceCriteria" header="Acceptance Criteria" sortable></Column>
                    <Column field="notes" header="Notes" sortable></Column>
                </DataTable>
                </Card>
            </div>
        );
    };

    const onRowExpand = (event) => {
    };

    const onRowCollapse = (event) => {
    };

    const allowExpansion = (rowData) => {
        return rowData.checklists.length > 0;
    };

    return (
        <>
            <ProjectContextDropdown onProjectChange={handleProjectSelection} />
            <Toast ref={toast} />

            <div className="card">
                <DataTable value={allChecklists} header={header} tableStyle={{ minWidth: '50rem' }}
                           expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                           onRowExpand={onRowExpand} onRowCollapse={onRowCollapse}
                           rowExpansionTemplate={rowExpansionTemplate}
                           dataKey="id">
                    <Column expander={allowExpansion} style={{ width: '5rem' }} />
                    {columns.map((col, i) => (
                        <Column key={col.field} field={col.field} header={col.header} />
                    ))}
                </DataTable>
            </div>
        </ >
    );
}
